import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { Question } from '../../../types/questionnaire';
import { BaseQuestionView } from './BaseQuestionView';

interface OptionsViewProps {
  question: Question;
}

export const OptionsView: React.FC<OptionsViewProps> = ({ question }) => {
  const selectedOptions = question.options?.filter(option => option.selected) ?? [];

  return (
    <BaseQuestionView question={question}>
      {selectedOptions.length === 0 ? (
        <Typography variant="body1" color="text.disabled">
          Немає відповіді
        </Typography>
      ) : (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 0.5 }}>
          {selectedOptions.map(option => (
            <Chip key={option.id} label={option.caption} size="small" />
          ))}
        </Box>
      )}
    </BaseQuestionView>
  );
};
